import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col
} from 'reactstrap';
import { required } from '@src/validation';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import axiosInstance from '@src/axios-instance';
import Select from 'react-select';

const fieldValidator = {
  unit_id: [required]
};

class AssignUnitModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};
    fields['unit_id'] = {
      value:
        props.entity.unit_id !== null
          ? {
              label:
                props.entity.unit.unit_no !== null
                  ? `${props.entity.unit.address_no} ${props.entity.unit.street}, ${props.entity.unit.unit_no}`
                  : `${props.entity.unit.address_no} ${props.entity.unit.street}, `,
              value: props.entity.unit_id
            }
          : null,
      visited: false,
      error: false
    };

    this.state = {
      ...fields,
      units: [],
      loaded: false
    };

    this.loadOptions();
  }

  loadOptions = () => {
    axiosInstance()
      .get(`/units/full-list/${this.props.entity.association_id}.json`)
      .then(response => {
        const newState = {
          loaded: true,
          units: response.data.units
        };
        this.setState(newState);
      })
      .catch(err => {
        console.log(err);
      });
  };

  updateForm = (event, name) => {
    const inputData = {
      value:
        event !== null && event.target !== undefined
          ? event.target.value
          : event === null
          ? ''
          : event,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    const updateState = {
      [name]: inputData
    };

    this.setState(updateState);
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] =
        formData[key].value.value !== undefined
          ? formData[key].value.value
          : formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    this.setState({ ...formData });

    if (isValid) {
      this.props.saveEntity(postData, this.props.toggle);
    }
    return false;
  };

  render = () => {
    const addressArr = [];
    const cognitoForm = this.props.entity.evidence_of_insurance_form;
    if (cognitoForm !== null) {
      addressArr.push(
        cognitoForm.property_address_line_1 +
          (cognitoForm.property_address_line_2.length > 0
            ? `, ${cognitoForm.property_address_line_2}`
            : '')
      );
      addressArr.push(
        cognitoForm.property_address_city +
          ', ' +
          `${cognitoForm.property_address_state} ${cognitoForm.property_address_postal_code}`
      );
    }

    const address = addressArr.filter(n => n).join('<br/>');

    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {'Assign a Unit'}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            {this.state.loaded && (
              <ModalBody className={'p-4'}>
                <div className={'pb-3'}>
                  <span className={'font-weight-bold color-blue'}>
                    Submitted Unit Address
                  </span>
                  <div dangerouslySetInnerHTML={{ __html: address }} />
                </div>

                <Row>
                  <Col xs={12}>
                    <div className={'form-group mb-1'}>
                      <span className={'font-weight-bold'}>Assign a Unit*</span>
                      <Select
                        value={this.state.unit_id.value}
                        options={this.state.units}
                        onInputChange={inputValue =>
                          this.setState({ inputValue })
                        }
                        placeholder={'Search by Address #, Street or Unit #'}
                        onChange={event => this.updateForm(event, 'unit_id')}
                      />
                    </div>
                  </Col>
                </Row>
              </ModalBody>
            )}
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Assign
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default AssignUnitModal;
